interface CTAProps {
  onContactClick: () => void;
  onInquiryClick: () => void;
}

export default function CTA({ onContactClick, onInquiryClick }: CTAProps) {
  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-gradient-to-br from-teal-600 to-blue-600">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
          今すぐ論文検索・入手を始めましょう
        </h2>
        <p className="text-sm sm:text-base md:text-lg text-white/90 mb-8 sm:mb-10 leading-relaxed">
          お気軽にお問い合わせください
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center max-w-md sm:max-w-none mx-auto">
          <button 
            onClick={onContactClick}
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white text-teal-600 rounded-lg font-semibold text-sm sm:text-base md:text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-file-search-line text-lg sm:text-xl"></i>
            論文見積依頼（無料）
          </button>
          <button 
            onClick={onInquiryClick}
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-transparent text-white border-2 border-white rounded-lg font-semibold text-sm sm:text-base md:text-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-mail-line text-lg sm:text-xl"></i>
            お問合せ
          </button>
        </div>
      </div>
    </section>
  );
}
